export default "__VITE_ASSET__4c939383__"